import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router-dom'

export const OpinionInduceRows = () => {
  return (
    <>
      <Row>
        <Col className="text-center p-5">
          <p className="fs-3">본인만의 투자 아이디어를 공유하고, 새로운 아이디어를 얻어가세요.</p>
          <Link className="btn btn-outline-primary" to="/articles/new">나만의 아이디어 공유하러 가기</Link>
        </Col>
      </Row>
      <Row>
        <Col>
          <ul>
            <li>글 작성을 완료한 회원에게만 다른 투자자들의 아이디어가 공개됩니다.</li>
            <li>글 작성 완료 후, 심사를 통해 승인 절차가 이루어집니다.</li>
          </ul>
        </Col>
      </Row>
    </>
  )
}
